import { useTranslation } from 'react-i18next'
import {
  SearchAutocomplete,
  SearchAutocompleteOption,
} from '@/components/inputs'
import { SoundReportStatuses } from '@/types'

type SoundRecordStatusMultiSelectProps = {
  value?: string
  onChange: (value: string | undefined) => void
}

export const SoundRecordStatusMultiSelect = ({
  value,
  onChange,
}: SoundRecordStatusMultiSelectProps): JSX.Element => {
  const { t } = useTranslation('forms')

  const options = Object.keys(SoundReportStatuses).map((key) => {
    const status = SoundReportStatuses[
      key as keyof typeof SoundReportStatuses
    ] as string

    return {
      label: t(`soundRecordStatus.${status}`),
      value: status,
    } as SearchAutocompleteOption
  })

  return (
    <SearchAutocomplete
      value={value}
      onChange={onChange}
      options={options}
      placeholder={t(`placeholders.soundRecordStatus`)}
      sort={false}
      fieldSx={{ width: 280 }}
    />
  )
}
